import { fetchWithTokenAndRegion } from '@adsk/acs-sc-web-platform-api';
import { CONTEXT_NAMES } from '@adsk/alloy-helpers';

import {
  BaseCombinedStore,
  PaginatedResponse,
  createPaginatedStore,
} from '../helpers/createDataModificationStore';
import { User } from '../types';

export type UsersStore = BaseCombinedStore<User>;

// Define response type for users API
type UsersResponse = {
  pagination: {
    limit: number;
    offset: number;
    totalResults: number;
    nextUrl?: string;
    previousUrl?: string;
  };
  results: User[];
};

const handlePendingUsers = (users: User[]) =>
  users.map((user) => ({
    ...user,
    name:
      user.name === 'New Member' || (!user.name && user.status === 'pending')
        ? user.email
        : user.name,
  }));

// Custom fetch function to handle users API response format and user processing
const fetchUsersWithProcessing = async (
  url: string,
): Promise<PaginatedResponse<User>> => {
  const response = await fetchWithTokenAndRegion<UsersResponse>(url);
  const processedUsers = handlePendingUsers(response.results);

  return {
    ...response,
    results: processedUsers,
  };
};

export const useUsersStore = () =>
  createPaginatedStore<User>({
    contextName: CONTEXT_NAMES.UsersContext,
    fetchFunction: fetchUsersWithProcessing,
  })();
